<script setup lang="ts">
defineOptions({
  ssr: true,
  client: false,
})
definePageMeta({
  auth: false,
})

const { data: posts } = useAsyncData(async () => await rpc().public_posts.getPosts())
const appName = 'GymBuddy'
const { loggedIn, signOut } = useAuth()
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex flex-col" no-client>
    <TopToolbar />

    <!-- Header -->
    <header class="bg-white shadow-sm">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="py-12 sm:py-16 lg:py-20 text-center">
          <h1 class="text-4xl font-extrabold text-gray-900 sm:text-5xl lg:text-6xl">
            Latest Blog Posts
          </h1>
          <p class="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
            Stay up to date with our latest news, updates, and insights
          </p>
        </div>
      </div>
    </header>

    <main class="flex-1 w-full">
      <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            v-for="post in posts"
            :key="post.id"
            class="blog-card bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-200 hover:shadow-xl">
            <div class="p-6">
              <h2 class="text-2xl font-bold text-gray-900 mb-4">{{ post.title }}</h2>
              <p class="text-gray-600 mb-4 line-clamp-3">{{ post.content }}</p>
              <div class="flex justify-between items-center text-sm text-gray-500">
                <span>{{ new Date(post.createdAt).toLocaleDateString() }}</span>
                <NuxtLink :to="`/blog/${post.id}`" class="text-black font-medium hover:underline">
                  Read more →
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- Footer -->
    <footer class="bg-gray-800 mt-auto">
      <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="text-white">
            <div class="flex items-center">
              <Icon name="lucide:dumbbell" class="h-8 w-8" />
              <span class="ml-2 text-xl font-bold">{{ appName }}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
.blog-card {
  transform: translateY(0);
  transition: all 0.3s ease;
}

.blog-card:hover {
  transform: translateY(-4px);
}
</style>
